function HeroTile() {
  return (
    <section className="bentolio-card bentolio-area-hero">
      <div className="hero-tile__inner">
        <h1 className="display-text">
          Making Every Celebration Feel Like A Dream Come True
        </h1>
        <img
          src="/images/pbj-logo.png"
          alt="Peanut Butter & Jelly Event Decor"
          className="hero-logo"
        />
      </div>
    </section>
  );
}

export default HeroTile;
